export const ROUTE_PATH = '/efs-users';
